import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'

import {
  Company,
  Deploy,
  PaginateDeploy,
  Profile,
} from '@cyborg-monorepo/hunter/common'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'

type DeployStatus = 'notDeployed' | 'staged' | 'deployed' | 'outdated'

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  public getCompanyDetails = (): Observable<Company> => {
    return this.httpClient.get<Company>(
      `${this.verityEnvironmentService.apiUrl}/company`,
    )
  }

  public getStagedDeploys = (
    size: number,
    page: number,
  ): Observable<PaginateDeploy> => {
    return this.httpClient.get<PaginateDeploy>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/staged?size=${size}&page=${page}`,
    )
  }

  public getDeployedDeploys = (
    size: number,
    page: number,
  ): Observable<PaginateDeploy> => {
    return this.httpClient.get<PaginateDeploy>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/deployed?size=${size}&page=${page}`,
    )
  }

  public getOutdatedDeploys = (
    size: number,
    page: number,
  ): Observable<PaginateDeploy> => {
    return this.httpClient.get<PaginateDeploy>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/outdated?size=${size}&page=${page}`,
    )
  }

  public getDeployStatus = (
    huntPackageUUID: string,
  ): Observable<Deploy & { status: DeployStatus }> => {
    return this.httpClient.get<Deploy & { status: DeployStatus }>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/${huntPackageUUID}`,
    )
  }

  public markAsStaged = (huntPackageUUID: string): Observable<Deploy> => {
    return this.httpClient.post<Deploy>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/${huntPackageUUID}/stageDeploy`,
      null,
    )
  }

  public markAsDeployed = (huntPackageUUID: string): Observable<Deploy> => {
    return this.httpClient.post<Deploy>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/${huntPackageUUID}/markDeployed`,
      null,
    )
  }

  public removeDeployed = (huntPackageUUID: string): Observable<Deploy> => {
    return this.httpClient.post<Deploy>(
      `${this.verityEnvironmentService.apiUrl}/company/deploys/${huntPackageUUID}/removeDeployed`,
      null,
    )
  }

  public getUsers = (): Observable<Array<Profile>> => {
    return this.httpClient.get<Array<Profile>>(
      `${this.verityEnvironmentService.apiUrl}/company/users`,
    )
  }

  public reactivateCompany(): Observable<Company> {
    return this.httpClient.put<Company>(
      `${this.verityEnvironmentService.apiUrl}/company/reactivate`,
      null,
    )
  }
}
